<template>
  <v-layout>
    <v-flex>
      <v-list>
        <v-list-tile v-for="(item, i) in choices" :key="i">
          <v-list-tile-content>
            <v-list-tile-title>{{ item.label }} - {{ item.value }} points</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
// import axios from 'axios'

export default {
  // data () {
  //   return {
  //     token: JSON.parse(localStorage.getItem('token')),
  //     choices: []
  //   }
  // },
  // methods: {
  //   getChoicesByQuestionId (questionId) {
  //     axios.get(this.apiUrl + '/choices', {
  //       headers: {
  //         'Authorization': 'Bearer ' + this.token.access_token
  //       }
  //     }).then((res) => {
  //       console.log(res.data)
  //       this.choices = res.data
  //     })
  //   }
  // },
  // mounted () {
  //   this.getChoicesByQuestionId(this.questionId)
  // },
  props: {
    apiUrl: String,
    questionId: Number,
    choices: Array
  }
}
</script>


// WEBPACK FOOTER //
// src/components/admin/module/question/choice.vue